import { createApiAction } from 'src/api';

export const FETCH_VENDORS_START = 'vendors/fetch_vendors_start';
export const FETCH_VENDORS_SUCCESS = 'vendors/fetch_vendors_success';
export const FETCH_VENDORS_FAILURE = 'vendors/fetch_vendors_failure';

export const ADD_VENDOR_START = 'vendors/add_vendor_start';
export const ADD_VENDOR_SUCCESS = 'vendors/add_vendor_success';
export const ADD_VENDOR_FAILURE = 'vendors/add_vendor_failure';

export const UPDATE_VENDOR_START = 'vendors/update_vendor_start';
export const UPDATE_VENDOR_SUCCESS = 'vendors/update_vendor_success';
export const UPDATE_VENDOR_FAILURE = 'vendors/update_vendor_failure';

export const DELETE_VENDOR_START = 'vendors/delete_vendor_start';
export const DELETE_VENDOR_SUCCESS = 'vendors/delete_vendor_success';
export const DELETE_VENDOR_FAILURE = 'vendors/delete_vendor_failure';

export const fetchVendors = (
  { page = 1, pageSize = 999, id = null, name = null } = {
    page: 1,
    pageSize: 999,
  }
) => {
  const idParam = id ? `&id=${encodeURIComponent(id)}` : '';
  const nameParam = name ? `&id=${encodeURIComponent(name)}` : '';

  return createApiAction(
    {
      path: `/api/v1/vendors/?page=${page}&page_size=${pageSize}${idParam}${nameParam}`,
    },
    [FETCH_VENDORS_START, FETCH_VENDORS_SUCCESS, FETCH_VENDORS_FAILURE]
  );
};

export const addVendor = ({
  businessEntityType,
  businessName,
  ssn,
  naicsCode,
  primaryAddress,
  primaryAddress2,
  primaryCity,
  primaryState,
  primaryZipcode,
  businessEmail,
  primaryPhone,
  otherPhone,
  website,
  registeredState,
  goodsAndServicesProvided,
  isApproved,
  isDenied,
  isArchived,
}) =>
  createApiAction(
    {
      path: `/api/v1/vendors/`,
      method: 'POST',
      body: {
        vendor_business_entity_type: businessEntityType,
        vendor_business_name: businessName,
        vendor_ssn_new: ssn,
        _vendor_social_security_enc: ssn,
        vendor_naics_code: naicsCode,
        vendor_primary_address: primaryAddress,
        vendor_primary_address_2: primaryAddress2,
        vendor_primary_city: primaryCity,
        vendor_primary_state: primaryState,
        vendor_primary_zipcode: primaryZipcode,
        vendor_business_email: businessEmail,
        vendor_primary_phone: primaryPhone,
        vendor_other_phone: otherPhone,
        vendor_website: website,
        vendor_registered_state: registeredState,
        vendor_goods_and_services_provided: goodsAndServicesProvided,
        vendor_is_approved: isApproved,
        vendor_is_denied: isDenied,
        vendor_is_archived: isArchived,
      },
    },
    [ADD_VENDOR_START, ADD_VENDOR_SUCCESS, ADD_VENDOR_FAILURE]
  );

export const updateVendor = ({
  vendorId,
  businessEntityType,
  businessName,
  ssn,
  naicsCode,
  primaryAddress,
  primaryAddress2,
  primaryCity,
  primaryState,
  primaryZipcode,
  businessEmail,
  primaryPhone,
  otherPhone,
  website,
  registeredState,
  goodsAndServicesProvided,
  isApproved,
  isDenied,
  isArchived,
}) =>
  createApiAction(
    {
      path: `/api/v1/vendors/${vendorId}/`,
      method: 'PUT',
      body: {
        vendor_business_entity_type: businessEntityType,
        vendor_business_name: businessName,
        vendor_ssn_new: ssn,
        _vendor_social_security_enc: ssn,
        vendor_naics_code: naicsCode,
        vendor_primary_address: primaryAddress,
        vendor_primary_address_2: primaryAddress2,
        vendor_primary_city: primaryCity,
        vendor_primary_state: primaryState,
        vendor_primary_zipcode: primaryZipcode,
        vendor_business_email: businessEmail,
        vendor_primary_phone: primaryPhone,
        vendor_other_phone: otherPhone,
        vendor_website: website,
        vendor_registered_state: registeredState,
        vendor_goods_and_services_provided: goodsAndServicesProvided,
        vendor_is_approved: isApproved,
        vendor_is_denied: isDenied,
        vendor_is_archived: isArchived,
      },
    },
    [UPDATE_VENDOR_START, UPDATE_VENDOR_SUCCESS, UPDATE_VENDOR_FAILURE]
  );

export const deleteVendor = vendorId =>
  createApiAction(
    {
      path: `/api/v1/vendors/${vendorId}/`,
      method: 'DELETE',
    },
    [DELETE_VENDOR_START, DELETE_VENDOR_SUCCESS, DELETE_VENDOR_FAILURE]
  );
